import { createSelector } from 'reselect';
import { getEntities, getResults } from 'reducers';
import Immutable from 'immutable';
import { denormalize } from 'normalizr';
import { board } from 'schemas';

export const getBoards = createSelector(
  state => getResults(state).get('boards', Immutable.List()),
  state => getEntities(state),
  (result, entities) =>
    denormalize(
      result,
      board.schemasArray,
      entities,
    ),
);
